import { render, staticRenderFns } from "./SystemClientMinVersionOnPlatform.vue?vue&type=template&id=5fbf1c03&"
import script from "./SystemClientMinVersionOnPlatform.vue?vue&type=script&lang=js&"
export * from "./SystemClientMinVersionOnPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports